import React, { useState } from "react";
import { formatDateTime } from "../../helpers/utils";
import DentalConditionDetails from "./DentalConditionDetails";
import WellnessScoreSummaryInPrintPage from "./WellnessScoreSummaryInPrintPage";
import { useSelector } from "react-redux";

const WellnessScorePrintPage = (props) => {
  const { smartScanCaseReport, wellnessScoreSummary } = props;

  const logoUrl = useSelector(
    (state) => state?.appSettings?.settingsData?.logoUrl
  );
  const logo = require("./../../assets/images/" + logoUrl);

  function printWellnessReport() {
    window.print();
  }

  const [isLoadingCompleted, setIsLoadingCompleted] = useState({
    Cavities: false,
    "Defective Restoration": false,
    "Broken Tooth": false,
    "Plaque BuildUp": false,
    "Gum Inflammation": false
  });

  const updateIsLoadingCompletedStatus = (componentName, value) => {
    setIsLoadingCompleted((prevStatus) => ({
      ...prevStatus,
      [componentName]: value
    }));
  };

  // Determine if all children have sent 'true'
  const allComponentsLoaded = Object.values(isLoadingCompleted).every(
    (status) => status
  );

  return smartScanCaseReport && wellnessScoreSummary ? (
    <>
      <div
        style={{
          maxWidth: "797px",
          color: "#000",
          margin: "20px auto",
          padding: "20px 20px",
          fontFamily: "Arial, Helvetica, sans-serif",
          background: "#fff",
          minHeight: "600px"
        }}
      >
        <table
          cellSpacing={0}
          cellPadding={0}
          border={0}
          width="100%"
          style={{ fontSize: 14, marginBottom: 0 }}
          className="table111"
        >
          <tbody>
            <tr>
              <td width="33.33%" style={{ paddingBottom: 10 }}>
                <a className="p-0 d-inline-block" href="/dashboard">
                  <img src={logo} alt="" style={{ width: "100%" }} />
                </a>
              </td>
              <td width="33.33%" style={{ paddingBottom: 10 }} />
              <td
                align="right"
                width="33.33%"
                style={{ padding: "0px 0px 10px 0" }}
              >
                <button
                  style={{
                    backgroundColor: "#fff",
                    fontSize: 12,
                    color: "#3fbbeb",
                    padding: "3px 15px",
                    border: "1px solid #3fbbeb",
                    cursor: "pointer",
                    borderRadius: "50rem",
                    marginRight: 10
                  }}
                  className="noprint d-none"
                  data-bs-toggle="modal"
                  data-bs-target="#smartscan-print-share"
                >
                  Share
                </button>
                {!allComponentsLoaded && (
                  <button className="btn btn-secondary btn-sm text-nowrap mt-2 mt-md-0">
                    <i class="fa fa-circle-o-notch fa-spin"></i>
                    <span> Loading..</span>.
                  </button>
                )}
                {allComponentsLoaded && (
                  <button
                    onClick={printWellnessReport}
                    style={{
                      backgroundColor: "#3fbbeb",
                      fontSize: 12,
                      color: "#fff",
                      padding: "3px 15px",
                      border: "1px solid #3fbbeb",
                      cursor: "pointer",
                      borderRadius: "50rem"
                    }}
                    className="noprint"
                  >
                    <i className="fa fa-print" /> Print
                  </button>
                )}
              </td>
            </tr>
            <tr>
              <th
                style={{
                  verticalAlign: "top",
                  textAlign: "left",
                  fontSize: 14,
                  padding: "20px 5px",
                  width: "33.3%"
                }}
                className="text-break"
              >
                Scan Date:
                <span style={{ color: "#3fbbeb", paddingLeft: 10 }}>
                  {formatDateTime(
                    wellnessScoreSummary?.currentSmartScanDate,
                    "MM.DD.YYYY"
                  )}
                </span>
              </th>
              <th
                style={{
                  verticalAlign: "top",
                  textAlign: "left",
                  fontSize: 14,
                  padding: "20px 5px",
                  width: "33.3%"
                }}
                className="text-break"
              >
                Patient Name:
                <span style={{ color: "#3fbbeb", paddingLeft: 10 }}>
                  {smartScanCaseReport?.patient?.fullName}
                </span>
              </th>
              <th
                style={{
                  verticalAlign: "top",
                  textAlign: "end",
                  fontSize: 14,
                  padding: "20px 5px",
                  width: "33.3%"
                }}
                className="text-break"
              >
                Patient DOB:
                <span style={{ color: "#3fbbeb", paddingLeft: 10 }}>
                  {formatDateTime(
                    smartScanCaseReport?.patient?.dateOfBirth,
                    "MM.DD.YYYY"
                  )}
                </span>
              </th>
            </tr>
            <WellnessScoreSummaryInPrintPage
              wellnessScoreSummary={wellnessScoreSummary}
            />
            <tr>
              <td colSpan={3}>
                <table width="100%">
                  <tbody>
                    <DentalConditionDetails
                      dentalConditionData={smartScanCaseReport?.cavity}
                      title={"Cavities"}
                      updateIsLoadingCompletedStatus={
                        updateIsLoadingCompletedStatus
                      }
                    />

                    <DentalConditionDetails
                      dentalConditionData={
                        smartScanCaseReport?.defectiveRestoration
                      }
                      title={"Defective Restoration"}
                      updateIsLoadingCompletedStatus={
                        updateIsLoadingCompletedStatus
                      }
                    />

                    <DentalConditionDetails
                      dentalConditionData={smartScanCaseReport?.brokenTooth}
                      title={"Broken Tooth"}
                      updateIsLoadingCompletedStatus={
                        updateIsLoadingCompletedStatus
                      }
                    />

                    <DentalConditionDetails
                      dentalConditionData={smartScanCaseReport?.plaqueBuildUp}
                      title={"Plaque BuildUp"}
                      updateIsLoadingCompletedStatus={
                        updateIsLoadingCompletedStatus
                      }
                    />

                    <DentalConditionDetails
                      dentalConditionData={smartScanCaseReport?.gumInflammation}
                      title={"Gum Inflammation"}
                      updateIsLoadingCompletedStatus={
                        updateIsLoadingCompletedStatus
                      }
                    />
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  ) : (
    <></>
  );
};

export default WellnessScorePrintPage;
